const BASE_API = process.env.REACT_APP_BASE_URL;

const USER_API = `${BASE_API}/users`;
const MEDIA_API = `${BASE_API}/media`;
const SHOP_API = `${BASE_API}/shops`;
const CART_API = `${BASE_API}/carts`;
const WEDDING_API = `${BASE_API}/weddings`;
const PLANS_API = `${BASE_API}/plans`;
const REGISTRY_API = `${BASE_API}/registry`;
const SETTINGS_API = `${USER_API}/settings`;
const WALLET_API = `${BASE_API}/users/wallet`;
const PROFILE_API = `${BASE_API}/users/profile`;
const VENDOR_API = `${BASE_API}/vendors`;
const TRANSACTION_API = `${BASE_API}/transactions`;
const TIMELINE_API = `${BASE_API}/timeline`;

const API_MAP = {
	//user
	userLogin: `${USER_API}/login`,
	userSignup: `${USER_API}/signup`,
	userSignOut: `${USER_API}/sign-out`,
	googleLogin: `${USER_API}/auth/google/redirect`,
	fetchCurrency: `${USER_API}/wallet/currencies/view`,
	chooseCurrency: `${USER_API}/wallet/currencies/choose-default`,
	changePassword: `${USER_API}/change-password`,
	notifications: `${USER_API}/notifications/view`,
	addUserKyc: `${USER_API}/kyc/add-documents`,
	ratingFeedback: `${USER_API}/feedback/submit`,

	//Page Redirect
	redirect: `${USER_API}/verify?`,

	//Media
	WeddingStoryCover: `${MEDIA_API}/weddings/upload/story-cover`,
	UploadStoryMedia: `${MEDIA_API}/weddings/upload/story-content`,
	UploadShopItemImage: `${MEDIA_API}/weddings/upload/shop-item`,
	UploadWeddingPhotos: `${MEDIA_API}/weddings/upload/album`,
	UploadWeddingGift: `${MEDIA_API}/weddings/upload/gift`,
	UploadKycSelfie: `${MEDIA_API}/kyc/upload/selfie`,
	UploadKycDocument: `${MEDIA_API}/kyc/upload/document`,
	vendorCoverImage: `${MEDIA_API}/vendors/upload/cover`,
	vendorPortfolioImage: `${MEDIA_API}/vendors/upload/portfolio`,
	UploadWeddingPostImages: `${MEDIA_API}/weddings/upload/post`,

	//Timeline
	viewTimeline: `${TIMELINE_API}/view`,

	//Wedding
	ViewWeddingCouple: `${WEDDING_API}/view`,
	AddStoryContent: `${WEDDING_API}/add-edit-story`,
	UpdateStoryContent: `${WEDDING_API}/edit-story`,
	sendInvite: `${WEDDING_API}/invitations/send`,
	saveInvite: `${WEDDING_API}/invitations/save`,
	viewAllInvites: `${WEDDING_API}/invitations/view-all`,
	deleteInvite: `${WEDDING_API}/invitations/delete`,
	editInvite: `${WEDDING_API}/invitations/edit`,
	editWedding: `${WEDDING_API}/edit`,
	reactToWeddingPost: `${WEDDING_API}/posts/react`,
	commentWeddingPost: `${WEDDING_API}/posts/comment`,
	viewAllWeddingPost: `${WEDDING_API}/posts/view-all`,
	viewSingleWeddingPost: `${WEDDING_API}/posts/view-one`,
	deletePostComment: `${WEDDING_API}/posts/comment/delete`,
	sprayTimelinePost: `${WEDDING_API}/spray`,
	searchWedding: `${WEDDING_API}/search`,
	viewSingleWeddingPhoto: `${WEDDING_API}/photos/albums/view-one`,
	viewUpcomingWeddings: `${WEDDING_API}/invitations/view-upcoming`,
	enterWedding: `${WEDDING_API}/event/enter`,
	createWeddingPost: `${WEDDING_API}/posts/create`,

	// Shop
	createShopItem: `${SHOP_API}/create`,
	getShopItems: `${SHOP_API}/view-all`,
	editShopItem: `${SHOP_API}/edit`,
	deleteShopItem: `${SHOP_API}/delete`,
	deleteShopImage: `${SHOP_API}/delete-image`,

	// Cart
	AddToCart: `${CART_API}/add-item`,
	ViewAllCart: `${CART_API}/view-all`,
	ViewSelectedCart: `${CART_API}/view-one`,
	EditCartItemQuantity: `${CART_API}/edit-item-quantity`,

	//Plans
	createPlanTag: `${PLANS_API}/tags/create`,
	viewPlanTag: `${PLANS_API}/tags/view`,
	addPlan: `${PLANS_API}/add`,
	viewPlans: `${PLANS_API}/view-all`,
	updatePlan: `${PLANS_API}/update`,
	deletePlan: `${PLANS_API}/delete`,
	addTag: `${PLANS_API}/tags/add`,
	removeTag: `${PLANS_API}/tags/remove`,
	editPlan: `${PLANS_API}/edit`,

	//Registry
	addGift: `${REGISTRY_API}/gifts/add`,
	editGift: `${REGISTRY_API}/gifts/edit`,
	deleteGift: `${REGISTRY_API}/gifts/delete`,
	deleteGiftImg: `${REGISTRY_API}/gifts/delete-image`,
	fetchAllGift: `${REGISTRY_API}/gifts/view-all`,
	fetchDonations: `${REGISTRY_API}/donations`,
	thankDonor: `${REGISTRY_API}/donations/send-thanks`,
	donate: `${REGISTRY_API}/donations/donate`,

	//Settings
	addPartner: `${SETTINGS_API}/add-partner`,
	addPlanner: `${SETTINGS_API}/add-planner`,

	//Wallet
	changePin: `${WALLET_API}/change-pin`,
	setPin: `${WALLET_API}/set-pin`,
	forgotPin: `${WALLET_API}/forgot-pin`,
	resetPin: `${WALLET_API}/reset-pin`,
	transactionHistory: `${WALLET_API}/transaction-history`,
	viewAllWallets: `${WALLET_API}/view-all`,
	viewWallet: `${WALLET_API}/view`,
	walletStat: `${WALLET_API}/statistics`,
	viewBanks: `${WALLET_API}/banks/view`,
	updateBankDetails: `${WALLET_API}/withdrawal/update-bank`,
	withdrawableAmount: `${WALLET_API}/withdrawal/withdrawable`,
	withdrawFunds: `${WALLET_API}/withdrawal/withdraw`,
	updateBvn: `${WALLET_API}/update-bvn`,

	// Profile
	viewProfile: `${PROFILE_API}/view`,

	// Vendors
	viewCategories: `${VENDOR_API}/categories/view`,
	viewVendorDetails: `${VENDOR_API}/view`,
	viewAllVendors: `${VENDOR_API}/view`,
	createVendorStand: `${VENDOR_API}/stand/create`,
	editVendorStand: `${VENDOR_API}/stand/edit`,
	bookmarkVendor: `${VENDOR_API}/bookmark`,
	rateVendor: `${VENDOR_API}/rate`,
	addImagesVendorStand: `${VENDOR_API}/stand/add-images`,
	deleteVendorCoverImage: `${VENDOR_API}/stand/delete-image`,
	searchVendor: `${VENDOR_API}/stand/search`,

	// Transactions
	initializeTransaction: `${TRANSACTION_API}/initialize`,
	fundWallet: `${USER_API}/wallet/withdrawal/withdraw`,
};

export default API_MAP;
